
var __consoleStyle = "background: #444; color: #bada55; padding: 2px 5px; border-radius:2px",
  __consoleStyleAlt = "background: #339; color: #fff; padding: 2px 5px; border-radius:2px";
/*============================================================================
  Ajax the add to cart experience by revealing it in a side drawer
  Plugin Documentation - http://shopify.github.io/Timber/#ajax-cart
  (c) Copyright 2015 Shopify Inc. Author: Carson Shold (@cshold). All Rights Reserved.

  This file includes:
    - Basic Shopify Ajax API calls
    - Ajax cart plugin

  This requires:
    - jQuery 1.8+
    - handlebars.min.js (for cart template)
    - modernizr.min.js
    - snippet/ajax-cart-template.liquid

  Customized version of Shopify's jQuery API
  (c) Copyright 2009-2015 Shopify Inc. Author: Caroline Schnapp. All Rights Reserved.GG
==============================================================================*/
if ((typeof ShopifyAPI) === 'undefined') { ShopifyAPI = {}; }

/*============================================================================
  API Helper Functions
==============================================================================*/
function attributeToString(attribute) {
  if ((typeof attribute) !== 'string') {
    attribute += '';
    if (attribute === 'undefined') {
      attribute = '';
    }
  }
  return jQuery.trim(attribute);
};

/*============================================================================
  API Functions
==============================================================================*/
ShopifyAPI.onCartUpdate = function(cart) {
  // alert('There are now ' + cart.item_count + ' items in the cart.');
};

ShopifyAPI.updateCartNote = function(note, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: 'note=' + attributeToString(note),
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeUpdateCartNote.ajaxCart', note);
    },
    success: function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterUpdateCartNote.ajaxCart', [note, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorUpdateCartNote.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
      $body.removeClass('page--is-loading');
      $('.is-added').removeClass('is-added');
      $('.is-adding').removeClass('is-adding');
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeUpdateCartNote.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

ShopifyAPI.updateCartAttributes = function(attributes, callback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/update.js',
    data: { "attributes": attributes },
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeupdateCartAttributes.ajaxCart', attributes);
    },
    success: function(cart) {
      if (typeof callback === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      $body.trigger('afterupdateCartAttributes.ajaxCart', [attributes, cart]);
    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorupdateCartAttributes.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
      $body.removeClass('page--is-loading');
      $('.is-added').removeClass('is-added');
      $('.is-adding').removeClass('is-adding');
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeupdateCartAttributes.ajaxCart', [this, jqxhr, text]);
    }
  };
  
  jQuery.ajax(params);
};

ShopifyAPI.onError = function(XMLHttpRequest, textStatus) {
  var data = eval('(' + XMLHttpRequest.responseText + ')');
  if (!!data.message) {
    //alert(data.message + '(' + data.status  + '): ' + data.description);
    swal({
      title: 'Oops!',
      text:  data.description,
      type: 'error'
    });
  }
};

/*============================================================================
  POST to cart/add.js returns the JSON of the cart
    - Allow use of form element instead of just id
    - Allow custom error callback
==============================================================================*/
ShopifyAPI.addItemFromForm = function(form, callback, errorCallback) {
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: jQuery(form).serialize(),
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', form);
    },
    success: function(line_item) {
      if (typeof callback === 'function') {
        callback(line_item, form);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, form);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, form]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if ((typeof errorCallback) === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      $body.removeClass('page--is-loading');
      $('.is-added').removeClass('is-added');
      $('.is-adding').removeClass('is-adding');
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.addItem = function(id, qty, props, callback) {
  var $body = $(document.body),
      data = {
        quantity: qty,
        id: id
      };

  if(props){
    data.properties = props;
  }

  params = {
    type: 'POST',
    url: '/cart/add.js',
    data: data,
    dataType: 'json',
    beforeSend: function(jqxhr, settings) {
      $body.trigger('beforeAddItem.ajaxCart', false);
    },
    success: function(line_item) {
      
      /*FB Pixel Tracking: Add To Cart */
      var sku = [];
      sku.push(line_item.id);

      fbq('track', 'AddToCart', {
        content_type: 'product',
        content_ids: sku,
        value: Shopify.formatMoney(line_item.final_price, "{{ amount }}"),
        content_name: line_item.title,
        currency: window.Shopify.currency.active,
        contents: [{'id': line_item.id, 'quantity': line_item.quantity}]
      });
      /*END FB Pixel Tracking: View Variant */
      

      // Add upsell item from product page to the cart
      jQuery(document).ready(function() {
        if($('[name="upsell-checkbox"]').prop('checked')) {
          jQuery.post('/cart/add.js', {
            items: [
              {
                quantity: 1,
                id: $('[name="upsell-checkbox"]').val(),
              }
            ]
          });
        }
      });

      if (typeof callback === 'function') {
        callback(line_item, false);
      }
      else {
        ShopifyAPI.onItemAdded(line_item, false);
      }
      $body.trigger('afterAddItem.ajaxCart', [line_item, false]);
    },
    error: function(XMLHttpRequest, textStatus) {
      if (typeof errorCallback === 'function') {
        errorCallback(XMLHttpRequest, textStatus);
      }
      else {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
      }
      $body.removeClass('page--is-loading').trigger('errorAddItem.ajaxCart', [XMLHttpRequest, textStatus]);
      $('.is-added').removeClass('is-added');
      $('.is-adding').removeClass('is-adding');
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeAddItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

// Get from cart.js returns the cart in JSON
ShopifyAPI.getCart = function(callback) {
  $(document.body).trigger('beforeGetCart.ajaxCart');
  jQuery.getJSON('/cart.js', function (cart, textStatus) {
    if (typeof callback === 'function') {
      callback(cart);
    }
    else {
      ShopifyAPI.onCartUpdate(cart);
    }
    $(document.body).trigger('afterGetCart.ajaxCart', cart);
  });
};

// POST to cart/change.js returns the cart in JSON
ShopifyAPI.changeItem = function(line, quantity, callback) {
  
  var $body = $(document.body),
  params = {
    type: 'POST',
    url: '/cart/change.js',
    data: 'quantity=' + quantity + '&line=' + line,
    dataType: 'json',
    beforeSend: function() {
      $body.trigger('beforeChangeItem.ajaxCart', [line, quantity]);
    },
    success: function(cart) {

      if (typeof callback === 'function') {
        callback(cart);
      }
      else {
        ShopifyAPI.onCartUpdate(cart);
      }
      setTimeout(function() {
        $body.trigger('afterChangeItem.ajaxCart', [line, quantity, cart]);
      }, 3000);

    },
    error: function(XMLHttpRequest, textStatus) {
      $body.trigger('errorChangeItem.ajaxCart', [XMLHttpRequest, textStatus]);
      ShopifyAPI.onError(XMLHttpRequest, textStatus);
      $body.removeClass('page--is-loading');
      $('.is-added').removeClass('is-added');
      $('.is-adding').removeClass('is-adding');
    },
    complete: function(jqxhr, text) {
      $body.trigger('completeChangeItem.ajaxCart', [this, jqxhr, text]);
    }
  };
  jQuery.ajax(params);
};

/*============================================================================
  Ajax Shopify Add To Cart
==============================================================================*/
var ajaxCart = (function(module, $) {

  'use strict';

  // Public functions
  var init, loadCart, loadCartPage, updateQtySelectors;

  // Private general variables
  var settings, isUpdating, $body, $globalData;

  // Private plugin variables
  var $formContainer,
    $modalFormContainer,
    $addToCart,
    $extras,
    $cartCountSelector,
    $cartCostSelector,
    $cartContainer,
    $cartPageContainer,
    $drawerContainer,
    loadedCartObject,
    discountedGiftActive,
    discountedGiftVariantId,
    discountedGiftHandle,
    discountedGiftThreshold,
    discountedGiftMessage,
    meetsThreshold,
    hasDiscountedGift,
    discountedGiftPrice,
    discountedGiftComparePrice,
    giftIsFree,
    removedDiscountedGift,
    justRemovedDiscountedGift,
    declinedDiscountedGift,
    discountedGift,
    $hiddenTieredDiscountCode,
    $tieredDiscountMessage,
    hiddenTieredDiscountCode,
    tieredDiscountMessage,
    tier1Code,
    tier2Code,
    tier3Code,
    tier1Message,
    tier2Message,
    tier3Message,
    tier1Min,
    tier2Min,
    tier3Min,
    justAddedItem,
    justAddedBlock;

  // Private functions
  var updateCountPrice, formOverride, modalFormOverride, prepareInlineFormData, productAddsLoop, itemAddedRedirect, itemAddedCallback, itemAddedModalCallback, itemErrorCallback, cartUpdateCallback, getVariations, getShippingRate, buildCartData, buildCart, addCartSubmitEvents, buildCartPage, cartCallback, cartPageCallback, adjustCart, adjustCartCallback, getWarrantyItems, createQtySelectors, qtySelectors, validateQty, createProductBundles, createProductAdds, createProductRemoves, createCartAttributes, productRemovesLoop, productChangeLoop, clearButtonClasses, addDiscountedGift, removeDiscountedGift, checkForDiscountedGift,/*freeWarrantyCheck,*/ modalActionDiscountedGift;

  /*============================================================================
    Initialise the plugin and define global options
  ==============================================================================*/
  init = function (options) {
    // Default settings
    settings = {
      formSelector             : 'form[action^="/cart/add"]',
      modalFormSelector        : '.AddToCartFormModal',
      cartContainer            : '#CartContainer',
      cartPageContainer        : '#CartPageContainer',
      addToCartSelector        : 'input[type="submit"]',
      extrasSelector           : '.extras',
      cartCountSelector        : null,
      cartCostSelector         : null,
      moneyFormat              : '$',
      freeShippingAmount       : false,
      hasFreeShippingText      : '',
      freeShippingCodeText     : '',
      needsFreeShippingText    : '',
      giftWrapProduct          : false,
      warrantyProduct          : false,
      warrantyPercent          : 0,
      warrantyText             : '',
      aliveAndThriveText       : '',
      oversizeShippingProduct  : false,
      helperData               : {},
      extrasData               : false,
      customizerData           : false,
      disableAjaxCart          : false,
      enableQtySelectors       : true,
      modalEnabled             : true,
      cansSalesAssociate       : false,
      salesAssociates          : false,
      hasInvocaID              : false,
      currency                 : false,
      discountedGiftVariantId : 0,
      discountedGiftThreshold : 0,
      discountedGiftHandle : '',
      discountedGiftMessage : '',
      hiddenTieredDiscountCodeEl : '#HiddenTieredDiscountCode',
      tieredDiscountMessageEl : '#TieredDiscountMessage',
      tier1Min : 1000000000000,
      tier2Min : 1000000000000,
      tier3Min : 1000000000000,
      tier1Message: '',
      tier2Message: '',
      tier3Message: '',
      tier1Code: '',
      tier2Code: '',
      tier3Code: '',
    };

    // Override defaults with arguments
    $.extend(settings, options);

    // Select DOM elements
    $formContainer       = $(settings.formSelector);
    $modalFormContainer  = $(settings.modalFormSelector);
    $cartContainer       = $(settings.cartContainer);
    $cartPageContainer   = $(settings.cartPageContainer);
    $addToCart           = $formContainer.find(settings.addToCartSelector);
    $extras              = $formContainer.find(settings.extrasSelector);
    $cartCountSelector   = $(settings.cartCountSelector);
    $cartCostSelector    = $(settings.cartCostSelector);
    discountedGiftActive  = typeof settings.discountedGiftActive !== 'undefined' && settings.discountedGiftHandle.length > 0;
    discountedGiftVariantId = settings.discountedGiftVariantId;
    discountedGiftThreshold = settings.discountedGiftThreshold * 100;
    discountedGiftHandle = settings.discountedGiftHandle;
    discountedGiftMessage = settings.discountedGiftMessage;
    meetsThreshold = false;
    hasDiscountedGift = false;
    discountedGiftPrice = 0;
    discountedGiftComparePrice = 0;
    giftIsFree = false;
    justRemovedDiscountedGift  = false;
    tier1Min = parseFloat(settings.tier1Min);
    tier2Min = parseFloat(settings.tier2Min);
    tier3Min = parseFloat(settings.tier3Min);
    tier1Code = settings.tier1Code;
    tier2Code = settings.tier2Code;
    tier3Code = settings.tier3Code;
    tier1Message = settings.tier1Message;
    tier2Message = settings.tier2Message;
    tier3Message = settings.tier3Message;

    // General Selectors
    $body = $(document.body);

    $globalData = false;

    // Track cart activity status
    isUpdating = false;

    // Setup ajax quantity selectors on the any template if enableQtySelectors is true
    if (settings.enableQtySelectors) {
      qtySelectors(false, false);
    }

    // Take over the add to cart form submit action if ajax enabled
    if (!settings.disableAjaxCart && $addToCart.length) {
      formOverride();
    }

    // Run this function in case we're using the quantity selector outside of the cart
    adjustCart();
  };

  loadCart = function () {
    
    $body.addClass('drawer--is-loading');
    if(discountedGiftActive && discountedGiftHandle.length > 0){
      jQuery.ajax({
        dataType: "json",
        url: '/products/' + discountedGiftHandle,
        success: function(data){
          if(data && data.product){
            discountedGift = data.product;
            
            var discountedVariant = discountedGift.variants.length > 0 ? discountedGift.variants[0] : {};
            discountedGiftVariantId = discountedVariant.id;
            discountedGiftPrice = discountedVariant.price * 100;
            discountedGiftComparePrice = discountedVariant.compare_at_price;
            giftIsFree = parseInt(Math.ceil(discountedVariant.price), 10) === 0;
            var confirmData = {
              name: discountedGift.title,
              img: discountedGift.image.src,
              price: '$' + discountedVariant.price,
              message: discountedGiftMessage
            }
            // set up modal window for confirming gift
            if($("#GiftConfirmTemplate").length === 1){
              var confirmModalSource = $("#GiftConfirmTemplate").html();
              var confirmModalTemplate  = Handlebars.compile(confirmModalSource);
              $('body').append(confirmModalTemplate(confirmData));
              $('#BtnAddGiftDecline,#BtnAddGiftConfirm').off('click').on('click', modalActionDiscountedGift);
            }
          }
          ShopifyAPI.getCart(function(cart){
            cartUpdateCallback(cart);
          });
        },
        error: function(XMLHttpRequest, textStatus){
          console.error("could not get discounted gift: ", XMLHttpRequest);
          ShopifyAPI.getCart(function(cart){
            cartUpdateCallback(cart);
          });
        }
      });
    }else{
      ShopifyAPI.getCart(function(cart){
        cartUpdateCallback(cart);
      });
    }
  };

  loadCartPage = function (cart) {
    
    $body.addClass('page--is-loading');
    removedDiscountedGift = cart.attributes && cart.attributes["removed_gift_" + discountedGiftVariantId] === "true";
    declinedDiscountedGift = cart.attributes && cart.attributes["declined_gift_" + discountedGiftVariantId] === "true";
    //freeWarrantyCheck(cart);
    buildCartPage(cart);
    
  };

  updateCountPrice = function (cart) {
    
    if ($cartCountSelector) {
      $cartCountSelector.html(cart.item_count).removeClass('hidden-count');

      if (cart.item_count === 0) {
        $cartCountSelector.addClass('hidden-count');
      }
    }
    if ($cartCostSelector) {
      $cartCostSelector.html(Shopify.formatMoney(cart.total_price, settings.moneyFormat));
    }
  };

  formOverride = function () {
    $formContainer.on('submit', function(evt) {
      evt.preventDefault();
      $body.addClass('page--is-loading');
      $modalFormContainer.addClass('slide-out');

      var $form = $(evt.target);
      var $button = $form.find(settings.addToCartSelector);
      var isModal = $button.hasClass('modalLoad');

      // Add class to be styled if desired
      $button.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      var itemsData = prepareInlineFormData($form);
      
      productAddsLoop(itemsData, isModal);
    });
  };

  modalFormOverride = function () {
    justAddedItem= null;
    justAddedBlock = null;
    
    var $modalForm  = $(settings.modalFormSelector);

    $modalForm.on('submit', function(evt) {
      
      evt.preventDefault();



      var $form = $(evt.target);
      var $button = $form.find('button[type="submit"]');
      
      // Add class to be styled if desired
      $button.removeClass('is-added').addClass('is-adding');

      // Remove any previous quantity errors
      $('.qty-error').remove();

      var qty = $form.find('input[name="quantity"]').val();

      var id = $form.find('[name="adds[]"]').is(':radio') ?
        $form.find('[name="adds[]"]:checked').val() :
        $form.find('[name="adds[]"]').val();

      if($('#addOnBlock-' + id).length === 1){
        justAddedItem = id;
        justAddedBlock = $('#addOnBlock-' + id);
      }

      var props = $form.find('[name="adds[]"]').attr('data-bundled-with-id') ?
        {'_bundled_with':$form.find('[name="adds[]"]').attr('data-bundled-with-id')} :
        false;

      
      ShopifyAPI.addItem(id, qty, props, itemAddedCallback);
    });
  };

  prepareInlineFormData = function ($form){
    var items = [],
      item = {},
      props = {},
      variants = window.product.variants,
      vl,
      qty = parseInt($form.find('input[name="quantity"]').val(), 10),
      id = $form.find('#productSelect').val(),
      cartPrice = loadedCartObject.total_price,
      currentAddingPrice = 0;
    vl = variants.length;
    for(var i = 0; i < vl; i++){
      if(variants[i].id === parseInt(id, 10)){
        // cartPrice += variants[i].price;
        currentAddingPrice += qty * variants[i].price;
        break;
      }
    }
    
    if(variant_meta[id].can_gift_wrap){
      props.can_gift_wrap = variant_meta[id].can_gift_wrap;
    }

    if(variant_meta[id]._can_warranty){
      props._can_warranty = variant_meta[id]._can_warranty;
    }

    if(variant_meta[id].has_oversize_shipping){
      props.has_oversize_shipping = variant_meta[id].has_oversize_shipping;
    }

    if(variant_meta[id].oversize_shipping_fee){
      props._oversize_shipping_fee = parseInt(variant_meta[id].oversize_shipping_fee);
    }

    if(variant_meta[id]._email_delivery_notice){
      props._email_delivery_notice = variant_meta[id]._email_delivery_notice;
    }

    if(variant_meta[id]._growing_zone_release){
      props._growing_zone_release = variant_meta[id]._growing_zone_release;
    }

    if(variant_meta[id]._email_delivery_notice_date){
      props._email_delivery_notice_date = variant_meta[id]._email_delivery_notice_date;
    }

    $form.find('input[name="related[]"]').each(function(){
      var $el = $(this);
      if($el.closest('.field-group').hasClass('has-options')){
        if($el.closest('.field-group').find('input[name="qty_related_option[]"]').length > 0){
          if($el.prop('checked')){
            var item = {},
                props = {};

            var item = {
              quantity: $el.closest('.field-group').find('input[name="qty_related_option[]"]').val(),
              id: $el.val(),
              properties: props
            };
            
            items.push(item);
          }
        }
        else if($el.prop('checked')){
          var item = {},
              props = {};

          item = {
            quantity: qty,
            id: $el.val(),
            properties: props
          };
          
          items.push(item);
        }
      }
      else{
        if($el.next('.product-selector').find('input[name="qty_related[]"]').length > 0){
          if($el.next('.product-selector').find('input[name="qty_related[]"]').val() > 0){
            var item = {},
                props = {};

            item = {
              quantity: $el.next('.product-selector').find('input[name="qty_related[]"]').val(),
              id: $el.val(),
              properties: props
            };
            
            items.push(item);
          }
        }
        else if($el.prop('checked')){
          var item = {},
              props = {};

          item = {
            quantity: qty,
            id: $el.val(),
            properties: props
          };
          
          items.push(item);
        }
      }
    });

    $form.find('input[name="bundle[]"]').each(function(){
      var $el = $(this);
      if($el.closest('.field-group').hasClass('has-options')){
        if($el.closest('.field-group').find('input[name="qty_bundle_option[]"]').length > 0){
          if($el.prop('checked')){
            var item = {},
                props = {};

            item = {
              quantity: $el.closest('.field-group').find('input[name="qty_bundle_option[]"]').val(),
              id: $el.val(),
              properties: props
            };
            
            items.push(item);
          }
        }
        else if($el.prop('checked')){
          var item = {},
              props = {'_bundled_with':id};

          item = {
            quantity: qty,
            id: $el.val(),
            properties: props
          };
          
          items.push(item);
        }
      }
      else{
        if($el.next('.product-selector').find('input[name="qty_bundle[]"]').length > 0){
          if($el.next('.product-selector').find('input[name="qty_bundle[]"]').val() > 0){
            var item = {},
                props = {};

            item = {
              quantity: $el.next('.product-selector').find('input[name="qty_bundle[]"]').val(),
              id: $el.val(),
              properties: props
            };
            
            items.push(item);
          }
        }
        else if($el.prop('checked')){
          var item = {},
              props = {'_bundled_with':id};

          item = {
            quantity: qty,
            id: $el.val(),
            properties: props
          };
          
          items.push(item);
        }
      }
    });
    
    var item = {
      quantity: qty,
      id: id,
      properties: props
    };
    
    items.unshift(item);
    
    
    if(!hasDiscountedGift && (cartPrice + currentAddingPrice) > (discountedGiftThreshold - discountedGiftPrice) && discountedGiftActive && !removedDiscountedGift && !declinedDiscountedGift && giftIsFree){
      // addDiscountedGift();
      
      items.push({
        quantity: 1,
        id: discountedGiftVariantId,
        properties: {}
      });
      
    }
    return items;
  }

  addDiscountedGift = function(){
    ShopifyAPI.addItem(discountedGiftVariantId, 1, {}, function(data){
      
      jQuery.post('/cart/update.js', "attributes[has_gift_" + discountedGiftVariantId + "]=true").always(function(){
        hasDiscountedGift = true;
        ShopifyAPI.getCart(cartUpdateCallback);
      });
    });
  }

  removeDiscountedGift = function(line, callback){
    jQuery.ajax({
      type: 'POST',
      url: '/cart/update.js',
      data: 'updates[' + discountedGiftVariantId +']=0&attributes[has_gift_' + discountedGiftVariantId + ']=false',
      dataType: 'json',
      success: function(cart) {
        
        if (typeof callback === 'function') {
          callback(cart);
        }
      },
      error: function(XMLHttpRequest, textStatus) {
        ShopifyAPI.onError(XMLHttpRequest, textStatus);
        $body.removeClass('page--is-loading');
        $('.is-added').removeClass('is-added');
        $('.is-adding').removeClass('is-adding');
      }
    });
  }

  checkForDiscountedGift = function(cart, addIfMissing, callback){
    
    /**
     * we might have the gift in the cart but not meet the threshold - remove it from cart and attributes
     * we might have the gift in the cart but not in the attributes - update attributes if we meet the threshold
     * we might have the gift in the attributes but not in the cart - add it if we meet the threshold, update attributes if we do not meet threshold
     * we might meet the threshold but not have the gift the cart nor attributes - add it and update attributes if it's free
     * we might have declined or just removed the discounted gift - remove it from attributes
     * we might have a quantity of the gift in the cart different than 1 - reset it to 1
     */
    var items = cart.items;
    var giftInAttrs = cart.attributes && cart.attributes["has_gift_" + discountedGiftVariantId] === "true";
    var giftInCart = false;
    var giftQuantity = 1;
    var itemsLength = items.length;
    var itemLine = 0;
    meetsThreshold = discountedGiftActive && cart.total_price - discountedGiftPrice >= discountedGiftThreshold;
    for(var i = 0; i < itemsLength; i++){
      if(items[i].variant_id === discountedGiftVariantId){
        giftInCart = true;
        giftQuantity = items[i].quantity;
        itemLine = i + 1;
        
        break;
      }
    }
    // by now we know if it's in the cart , if it's in the attributes, and if we meet the threshold: make the necessary updates/additions/removals
    if(meetsThreshold){
      
      if(!giftInCart && !giftInAttrs){
        
        if(!declinedDiscountedGift && !justRemovedDiscountedGift && !giftIsFree){
          $('#modalConfirmGiftBg').addClass('is-showing');
        }else{
          if(addIfMissing){
            
            addDiscountedGift();
          }
        }
      }else if(!giftInCart){
        
        if(addIfMissing){
          
          addDiscountedGift();
        }
      }else if(!giftInAttrs){
        
        jQuery.post('/cart/update.js', "attributes[has_gift_" + discountedGiftVariantId + "]=true").always(function(){
          
          if(giftQuantity !== 1){
            
            ShopifyAPI.changeItem(itemLine, 1, function(updatedCart){
              cartCallback(updatedCart);
            });
          }
        });
      }
    }else{
      
      // remove the gift from the cart
      if(itemLine > 0){
        
        removeDiscountedGift(itemLine, function(updatedCart){
          console.log("%citem removed, updated cart", __consoleStyleAlt, updatedCart);
          cartUpdateCallback(updatedCart);
        });
      }
    }
  };

  //freeWarrantyCheck = function(cart) {

    //var items = cart.items;
    //var cartAmount = cart.total_price;
    //var warrantyTotal = 0;

    //for(var i=0; i < items.length; i++){
      //if(items[i].properties['_can_warranty']) {
        //warrantyTotal += items[i].price * items[i].quantity;
      //}
    //}

    //var warrantyPriceTag = (warrantyTotal * 0.1);

    //if(cartAmount - warrantyPriceTag >= 19900) {

     //for(var i=0; i < items.length; i++){
       //if(items[i].id == 13941255798836) {
        //var itemLine = i + 1;
        //var qty = 0;
        //cart.items.splice(itemLine - 1, 1);
          //ShopifyAPI.changeItem(itemLine, qty, cartUpdateCallback);
        //}
      //}
   //}
  //};

  productAddsLoop = function(items, modal) {
    
    var item = items.shift();
    var id = item.id,
        qty = item.quantity,
        props = item.properties,
        itsTheGift = parseInt(id, 10) === parseInt(discountedGiftVariantId, 10);
    

    var addTheItem = function(id, qty, props, modal){
      
      if(items.length > 0){
        ShopifyAPI.addItem(id, qty, props, function(cart){
          productAddsLoop(items, modal);
        });
      }else{
        if(settings.modalEnabled && modal){
          ShopifyAPI.addItem(id, qty, props, function(product){
            itemAddedModalCallback(product, qty);
          });
        }
        else {
          ShopifyAPI.addItem(id, qty, props, function(product){
            itemAddedRedirect();
          });
        }
      }
    };

    if(itsTheGift){
      jQuery.post('/cart/update.js', "attributes[has_gift_" + discountedGiftVariantId + "]=true").always(function(){
        addTheItem(id, qty, props, modal);
      });
    }else{
      addTheItem(id, qty, props, modal);
    }
  }

  itemAddedRedirect = function (product) {
    $addToCart.removeClass('is-adding').addClass('is-added');
    $body.find('.is-adding').removeClass('is-adding').addClass('is-added');

    setTimeout(clearButtonClasses, 3000);

    window.location.replace('/cart');
  };

  itemAddedCallback = function (product) {
    $('.is-adding').removeClass('is-adding').addClass('is-added');
    if(justAddedBlock){
      justAddedBlock.slideUp(300, function(){
        justAddedBlock.remove();
        var newQty = parseInt($(".items-added").text(), 10) + 1;
        $(".items-added").text(newQty + ' Items added to your cart');
      });
    }

    setTimeout(clearButtonClasses, 3000);

    ShopifyAPI.getCart(cartUpdateCallback);
  };

  itemAddedModalCallback = function (product, qty) {
    
    $addToCart.removeClass('is-adding').addClass('is-added');

    setTimeout(clearButtonClasses, 3000);

    
    var extrasData = $.extend(true, {}, settings.extrasData);
    var customizerData = $.extend(true, {}, settings.customizerData);

    // Handlebars.js cart layout
    Handlebars.registerPartial('options', $("#ModalExtrasOptionsTemplate").html());

    var data = {
          'added': product,
          'related': (extrasData[product.variant_id]) ? extrasData[product.variant_id] : false,
          'bundles': (customizerData[product.variant_id]) ? customizerData[product.variant_id] : false
        },
        source = $("#ModalExtrasTemplate").html(),
        template = Handlebars.compile(source);

        var qtext0 = "Items added to your cart",
            qtext1 = "Item added to your cart",
            qtext2 = "Items added to your cart";

        data.added.formatted_price = Shopify.formatMoney(data.added.price, settings.moneyFormat);

        if(qty == 1){
          data.added.quantity_text = qty + " " + qtext1;
        }
        else if(qty < 1){
          data.added.quantity_text = qty + " " + qtext0;
        }
        else {
          data.added.quantity_text = qty + " " + qtext2;
        }

        if(data.bundles){
          data.bundles.max = qty;
          for(var i=0; i<data.bundles.length; i++){
            for(var variant_id in data.bundles[i].variants) {
              data.bundles[i].variants[variant_id].bundle_with = product.variant_id;
            }
          }
        }
    
    // Handlebars.js cart layout
    var modalData = {
          content: template(data)
        },
        modalSource = $("#ModalHolderTemplate").html(),
        modalTemplate = Handlebars.compile(modalSource);

    $body.append(modalTemplate(modalData));

    $('.modal-wrapper').on('click', function(e){
      if($(e.target).closest('.extras').length <= 0){
        $('.modal-wrapper').off('click').remove();
      }
    });

    $('.atc-modal-close').on('click', function(e) {
      e.preventDefault();
      $('.modal-wrapper').off('click').remove();
    });

    $('.btn--cs').on('click', function(e) {
      e.preventDefault();
      $('.modal-wrapper').off('click').remove();
    });

    if (settings.enableQtySelectors) {
      qtySelectors(true, false);
    }


    if(product.variant_id === discountedGiftVariantId){
      
      jQuery.post('/cart/update.js', "attributes[has_gift_" + discountedGiftVariantId + "]=true").always(function(){
        modalFormOverride();
        ShopifyAPI.getCart(cartUpdateCallback);
      });
    }else{
      modalFormOverride();
      ShopifyAPI.getCart(cartUpdateCallback);
    }
  };

  clearButtonClasses = function(){
    $body.find('.is-added').removeClass('is-adding is-added').trigger('blur');
  }

  itemErrorCallback = function (XMLHttpRequest, textStatus) {
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    $addToCart.removeClass('is-adding is-added');

    if (!!data.message) {
      if (data.status == 422) {
        $formContainer.after('<div class="errors qty-error">'+ data.description +'</div>')
      }
    }
  };

  cartUpdateCallback = function (cart) {
    
    utmz.init(cart.attributes);
    //freeWarrantyCheck(cart);
    loadedCartObject = cart;
    updateCountPrice(cart);
    buildCart(cart);
  };

  getVariations = function (id, options) {
    var helper = settings.helperData;
    var variations = {};
    if(helper.hasOwnProperty(id)){
      $.each(options, function(index, option) {
        variations[helper[id][index]] = option;
      });
    }
    return variations;
  };

  getShippingRate = function (subtotal) {
    var return_rate = 0;
    for(var shipping_rate in shipping_rates){
      var r = shipping_rates[shipping_rate];
      if(r.max){
        if(subtotal >= r.min && subtotal < r.max){
          return_rate = r.rate;
        }
      }
      else {
        if(subtotal >= r.min){
          return_rate = r.rate;
        }
      }
    }
    return return_rate;
  }

  modalActionDiscountedGift = function(e){
    e.preventDefault();
    if($(e.target).attr('id') === "BtnAddGiftConfirm"){
      $('#modalConfirmGiftBg').removeClass('is-showing');
      addDiscountedGift();
    }else{
      jQuery.post('/cart/update.js', "attributes[declined_gift_" + discountedGiftVariantId + "]=true").always(function(){
        declinedDiscountedGift = true;
        $('#modalConfirmGiftBg').removeClass('is-showing');
      });
    }
  };


  buildCartData = function (cart) {
    

    var customizerData = $.extend(true, {}, settings.customizerData),
      totals = [],
      items = [],
      bundles = [],
      gift_wraps = [],
      quantity_fixes= [],
      _can_warranty = false,
      has_warranty = false,
      warranty_applied = false,
      can_gift_message = false,
      has_gift_message = false,
      is_gift = false,
      needs_oversize_shipping = false,
      has_oversize_shipping = false,
      oversize_shipping_quantity = 0,
      warranty_amount = 0,
      subtotal_adjustment_amount = 0,
      subtotals_row = {},
      warranty_row = false,
      oversize_row = false,
      shipping_amount = {},
      shipping_row = {},
      totals_row = {},
      item = {},
      data = {},
      has_tiered_discount = false,
      tiered_coupon_code = '',
      tiered_message = '',
      stored_invoca = '',
      cartAmount = cart.items_subtotal_price / 100;

    

    if(cart.attributes && cart.attributes['Gift Message']){
      has_gift_message = cart.attributes['Gift Message'];
    }

    if(cart.attributes && cart.attributes.gift){
      can_gift_message = true;
      is_gift = true;
    }

    // Add each item to our handlebars.js data
    $.each(cart.items, function(index, cartItem) {

      

      /* Hack to get product image thumbnail
       *   - If image is not null
       *     - Remove file extension, add _small, and re-add extension
       *     - Create server relative link
       *   - A hard-coded url of no-image
      */
      var prodImg = cartItem.image != null ?
        cartItem.image.replace(/(\.[^.]*)$/, "_medium$1").replace('http:', '') :
        "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      var prodImgMini = cartItem.image != null ?
        cartItem.image.replace(/(\.[^.]*)$/, "_100x100_crop_center$1").replace('http:', '') :
        "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";

      // Create item's data object and add to 'items' array
      item = {
        key: cartItem.key,
        id: cartItem.variant_id,
        sku: cartItem.sku,
        line: index + 1, // Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        imgMini: prodImgMini,
        name: cartItem.product_title,
        variations: getVariations(cartItem.product_id, cartItem.variant_options),
        variation: cartItem.variant_title,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        price: Shopify.formatMoney(cartItem.price, settings.moneyFormat),
        vendor: cartItem.vendor,
        linePrice: Shopify.formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: Shopify.formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true,
        is_warranty: false,
        is_gift_wrap: false,
        is_oversize_shipping: false,
        is_discounted_gift: false,
        gift_is_free: false,
        compare_at_price: 0,
      };

      var newproperties = {};
      var bundle = false;
      $.each(cartItem.properties, function(key, property) {
        switch(key) {
          case '_can_warranty':
            item._can_warranty = property;
            _can_warranty = true;
            warranty_amount = warranty_amount + cartItem.line_price;
            break;
          case 'can_gift_wrap':
            item.can_gift_wrap = property;
            break;
          case 'has_oversize_shipping':
            item.has_oversize_shipping = property;
            needs_oversize_shipping = true;
            oversize_shipping_quantity += item.itemQty;
            break;
          case '_bundled_with':
            bundle = property;
            break;
          case '_email_delivery_notice':
            item._email_delivery_notice = property;
            break;
          case '_growing_zone_release':
            item._growing_zone_release = property;
            break;
          case '_email_delivery_notice_date':
            item._email_delivery_notice_date = property;
            break;
          case '_surcharge':
          case '_oversize_shipping_fee':
            break;
          default:
            newproperties.key = property;
        }
      });

      item.properties = newproperties;

      if(variant_meta2[item.id] && variant_meta2[item.id].original_product_id){
        item.original_product_id = variant_meta2[item.id].original_product_id;
      }

      if(cartItem.product_id == settings.warrantyProduct.id){
        has_warranty = item;
        item.is_warranty = true;
        subtotal_adjustment_amount = subtotal_adjustment_amount + cartItem.line_price;
        warranty_row = {
          "type": "warranty",
          "label": item.name,
          "amount": item.linePrice,
        };
      }

      if(item.id == settings.giftWrapProduct){
        can_gift_message = true;
        item.is_gift_wrap = true;
      }

      if(item.id == settings.oversizeShippingProduct){
        has_oversize_shipping = item;
        item.is_oversize_shipping = true;
        subtotal_adjustment_amount = subtotal_adjustment_amount + cartItem.line_price;

        oversize_row = {
          "type": "oversize",
          "label": item.name,
          "amount": item.linePrice,
        };
      }

      if(item.id === discountedGiftVariantId){
        item.discounted_gift_message = settings.discountedGiftMessage;
        item.is_discounted_gift = true;
        item.compare_at_price = discountedGiftComparePrice;
        item.gift_is_free = cartItem.price === 0;
        hasDiscountedGift = true;
      }

      

      if(!bundle){
        items.push(item);
      }
      else {
        item.bundle_with_id = bundle;
        if(item.id == settings.giftWrapProduct){
          gift_wraps.push(item);
        }
        else{
          bundles.push(item);
        }
      }

    });

    

    $.each(items, function(index, item) {
      
      var compare_id = item.id;

      if(gift_wraps.length > 0){
        var giftWrapsLoop = [];
        while(gift_wraps.length > 0){
          var gift_wrap = gift_wraps.shift();
          
          if(gift_wrap.bundle_with_id == item.id){
          

          
            if(gift_wrap.itemQty != item.itemQty){
              quantity_fixes.push({'line':gift_wrap.line, 'qty': item.itemQty});
            }
            if(item.gift_wraps){
              
              item.gift_wraps.push(gift_wrap);
            }
            else {
              
              item.gift_wraps = [];
              item.gift_wraps.push(gift_wrap);
            }
            //gift_wraps.splice(gift_wraps[index3], 1);
            
          }
          else{
            giftWrapsLoop.push(gift_wrap);
          }

          
        }

        

        gift_wraps = giftWrapsLoop;

        
      }

      if(bundles.length > 0){
        var bundlesLoop = [];
        while(bundles.length > 0){
          var bundle = bundles.shift();
              
          if(bundle.bundle_with_id == item.id){
              

              
            if(bundle.itemQty > item.itemQty){
              quantity_fixes.push({'line':bundle.line, 'qty': item.itemQty});
            }
            if(item.bundles){
              
              item.bundles.push(bundle);
            }
            else {
              
              item.bundles = [];
              item.bundles.push(bundle);
            }
              
              
          }
          else{
            bundlesLoop.push(bundle);
          }

          
        }


        

        bundles = bundlesLoop;

        
      }

      if(customizerData){
        if(customizerData[item.id]){
          
          if(item.bundles){
            var newBundles = item.bundles;
          }
          else{
            var newBundles = [];
          }
          item.bundles = [];
          
          $.each(customizerData[item.id], function(index, cd) {
            var customizerAdded = false;

            if(newBundles){
              for(var i=0; i < newBundles.length; i++){
                

                if(cd.variants[newBundles[i].id]){
                  customizerAdded = true;

                  newBundles[i].in_cart = true;
                  newBundles[i].choices = cd.variants;
                  if(cd.name){
                    newBundles[i].has_choices = true;
                  }
                  if(cd.original_product_id){
                    newBundles[i].original_product_id = cd.original_product_id;
                  }
                  newBundles[i].choices[newBundles[i].id].is_choice = true;
                  item.bundles.push(newBundles[i]);
                }
              }
            }

            if(!customizerAdded){
              var data = {choices: cd.variants}
              if(cd.name){
                data.has_choices = true;
                data.name = cd.name;
              }
              if(cd.original_product_id){
                data.original_product_id = cd.original_product_id;
              }
              item.bundles.push(data);
            }
          });
        }
      }
    });
    

    if(!can_gift_message && has_gift_message){
      

      var attributes = {
        'Gift Message': ''
      };

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartAttributes(attributes, cartUpdateCallback);

      return false;
    }

    if(needs_oversize_shipping && !has_oversize_shipping){
        

        if(settings.oversizeShippingProduct){
          var props = {'_surcharge':true};
          ShopifyAPI.addItem(settings.oversizeShippingProduct, oversize_shipping_quantity, props, function(){
            ShopifyAPI.getCart(cartUpdateCallback);
          });
          return false;
        }
      }
    else if(!needs_oversize_shipping && has_oversize_shipping){
      

      productRemovesLoop([has_oversize_shipping]);
      return false;
    }
    else if(needs_oversize_shipping && has_oversize_shipping){
        if(has_oversize_shipping.itemQty != oversize_shipping_quantity){
          

          ShopifyAPI.changeItem(has_oversize_shipping.line, oversize_shipping_quantity, cartUpdateCallback);
          return false;
        }
      }

    if(has_warranty && !_can_warranty){
      

      productRemovesLoop([has_warranty]);
      return false;
    }
    else if(has_warranty && has_warranty.itemQty != 1){
      

      ShopifyAPI.changeItem(has_warranty.line, 1, cartUpdateCallback);
      return false;
    }

    

    if( (Array.isArray(bundles) && bundles.length) || (Array.isArray(gift_wraps) && gift_wraps.length) ){
      if(bundles.length && gift_wraps.length){
        
        var toRemove = bundles.concat(gift_wraps);
      }
      else if(bundles.length){
        
        var toRemove = bundles;
      }
      else if(gift_wraps.length){
        
        var toRemove = gift_wraps;
      }

      

      productRemovesLoop(toRemove);

      return false;
    }

    if(Array.isArray(quantity_fixes) && quantity_fixes.length ){
      

      productChangeLoop(quantity_fixes);

      return false;
    }

    if(settings.salesAssociates){
      var associates = [];
      for(var associate in settings.salesAssociates){
        associates.push(
          {
            name: settings.salesAssociates[associate],
            selected: (cart.attributes['Sales Associate'] == settings.salesAssociates[associate]) ? true : false,
          }
        );
      }
    }
    else{
      var associates = false;
    }

    if(settings.hasInovcaID) {
      var call_id = [];
      var phone_number = $('#invoca_phone').val();
      call_id.push(cart.attributes['invoca_id'] == phone_number)
    }

    subtotals_row = {
      "type": "subtotal",
      "label": "Subtotal",
      "amount": Shopify.formatMoney((cart.items_subtotal_price - subtotal_adjustment_amount), settings.moneyFormat),
    };

    shipping_amount = getShippingRate(cart.items_subtotal_price);
    shipping_row = {
      "type": "shipping",
      "label": "Estimated Shipping",
      "amount": Shopify.formatMoney(shipping_amount, settings.moneyFormat),
    };

    totals_row = {
      "type": "total",
      "label": "Estimated Total",
      "amount": Shopify.formatMoney( (cart.total_price + shipping_amount), settings.moneyFormat),
    };

    totals.push(subtotals_row);
    if(warranty_row){
      totals.push(warranty_row);
    }
    if(oversize_row){
      totals.push(oversize_row);
    }
    totals.push(shipping_row);
    totals.push(totals_row);

    // Gather all cart data and add to DOM
    data = {
      items: items,
      note: cart.note,
      itemPrice: Shopify.formatMoney(cart.items_subtotal_price, settings.moneyFormat),
      totalPrice: Shopify.formatMoney(cart.total_price, settings.moneyFormat),
      totalCartDiscount: cart.total_discount === 0 ? 0 : "You're saving [savings]".replace('[savings]', Shopify.formatMoney(cart.total_discount, settings.moneyFormat)),
      totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
      cansSalesAssociate: settings.cansSalesAssociate,
      salesAssociates: associates,
      hasInvocaID: settings.hasInvocaID,
      cartCount: cart.item_count,
      totals: totals
    }

    if(cart.total_price > (settings.freeShippingAmount * 100)) {
      data.freeShippingAmount = false;
      data.freeShippingText = settings.hasFreeShippingText;
      data.freeShippingCode = settings.freeShippingCodeText;
    }
    else{
      data.freeShippingAmount = Shopify.formatMoney(((settings.freeShippingAmount * 100)-cart.total_price), settings.moneyFormat);
      data.freeShippingText = settings.needsFreeShippingText.replace("[amt]", data.freeShippingAmount);
    }

    if(_can_warranty){
      data._can_warranty = true;

      if(warranty_amount > 0 ){
        data.warranty_amount = Shopify.formatMoney(Math.round(warranty_amount * (settings.warrantyPercent / 100)), settings.moneyFormat);
        data.warranty_text = settings.warrantyText.replace("[amt]", data.warranty_amount);
        data.alive_thrive_text = settings.aliveAndThriveText.replace("[amt]", data.warranty_amount);
      }
    }

    if(has_oversize_shipping) {
      data.cartCount = (cart.item_count - 1);
    }

    if(has_warranty){
      data.has_warranty = true;
      data.warranty_applied = true;
      data.warranty_line = has_warranty.line;
    }

    if(is_gift){
      can_gift_message = true;
      data.is_gift = true;
    }

    if(can_gift_message){
      data.can_gift_message = true;
    }

    if(needs_oversize_shipping){
      data.needs_oversize_shipping = true;
    }

    if(has_gift_message){
      data.gift_message = has_gift_message;
    }

    if(cartAmount > tier1Min){
      has_tiered_discount = true;
      if(cartAmount > tier3Min){
        tiered_coupon_code = tier3Code;
        tiered_message = tier3Message;
      } else {
        if(cartAmount > tier2Min){
          tiered_coupon_code = tier2Code;
          tiered_message = tier2Message;
        } else {
          tiered_coupon_code = tier1Code;
          tiered_message = tier1Message;
        }
      }
    }

    data.has_tiered_discount = has_tiered_discount;
    data.tiered_coupon_code = tiered_coupon_code;
    data.tiered_message = tiered_message;

    if (localStorage.getItem('invoca_phone') !== null) {
      stored_invoca = localStorage.getItem('invoca_phone');
      data.stored_invoca = stored_invoca;
    }

    

    return data;
  }

  buildCart = function (cart) {
    // Start with a fresh cart div
    
    $cartContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
      
      // Handlebars.js cart layout
      var data = {},
          source = $("#CartTemplateEmpty").html(),
          template = Handlebars.compile(source);
      $cartContainer.append(template(data));
      if(discountedGiftActive){
        jQuery.post('/cart/update.js', "attributes[has_gift_" + discountedGiftVariantId + "]=false").always(function(){
          cartCallback(cart);
        });
      }else{
        cartCallback(cart);
      }
    }else{
      // Handlebars.js cart layout
      var source = $("#CartTemplate").html(),
          template = Handlebars.compile(source),
          data = buildCartData(cart);

      if(data){
        $globalData = data;

        $cartContainer.append(template(data));

        cartCallback(cart);

        
        addCartSubmitEvents(cart);
        
      }
    }
  };

  addCartSubmitEvents = function (cart) {
    $('form.cart button[type="submit"]').on('click', function(e){
      e.preventDefault();

      /*FB Pixel Tracking: Initiate Checkout */
      var skus = [];
      var contents = [];

      $.each(cart.items, function(index, line_item) {
        skus.push(line_item.id);
        contents.push({'id': line_item.id, 'quantity': line_item.quantity});
      });

      fbq('track', 'InitiateCheckout', {
        content_ids: skus,
        value: Shopify.formatMoney(cart.total_price, "{{ amount }}"),
        currency: settings.currency,
        contents: contents,
        num_items: cart.item_count
      });
      /*END FB Pixel Tracking: View Variant */

      $(this).closest('form.cart').append('<input type="hidden" name="'+$(this).attr('name')+'" value="'+$(this).attr('name')+'"/>');
      $(this).closest('form.cart').trigger('submit');
    });
  }


  buildCartPage = function (cart) {
    
    // Start with a fresh cart div
    $cartPageContainer.empty();

    // Show empty cart
    if (cart.item_count === 0) {
    // Handlebars.js cart layout
      var data = {},
          source = $("#CartPageTemplateEmpty").html(),
          template = Handlebars.compile(source);
      $cartPageContainer.append(template(data));
      cartPageCallback(cart);
      return;
    }

    // Handlebars.js cart layout
    var source = $("#CartPageTemplate").html(),
        template = Handlebars.compile(source);

    if($globalData){
      data = $globalData;
    }
    else{
      data = buildCartData(cart);
    }

    if(data){
      $cartPageContainer.append(template(data));

      cartPageCallback(cart);
      createQtySelectors();
      createProductBundles();
      createProductAdds();
      createProductRemoves();
      createCartAttributes();

      $body.removeClass('page--is-loading');
    }
  };

  createProductBundles = function() {
    $cartPageContainer.find('.extra-options-toggler').on('change', function(e){
      $(e.target).closest('.cart__row').find('.extra-options').toggle();
    });
  }

  createProductAdds = function() {
    $cartPageContainer.find('[type="radio"][name^="adds["]').closest('.field-group-opt').children('label').on('click', function(e){
      e.preventDefault();
      if($(e.target).parent().hasClass('field-group-opt')){
        var target = $(e.target);
      }
      else {
        var target = $(e.target).closest('label');
      }
      target.find('input[type="radio"]').prop('checked', 'checked').trigger('change');
    });

    $cartPageContainer.find('[name^="adds["]').on('change', function(e){
      $body.addClass('page--is-loading');

      e.preventDefault();
      
      if(e.target.checked){
        
        var id = $(e.target).attr("id") === "add_warranty" ? $("#add_warranty").val() : $(e.target).val(),
            qty = $(e.target).attr('data-qty'),
            props = false,
            line = $(e.target).attr('data-line');

        if($(e.target).attr('data-bundle-with-id')){
          props =  {'_bundled_with':$(e.target).attr('data-bundle-with-id')};
        }
        
        if(line){
          ShopifyAPI.changeItem($(e.target).attr('data-line'), 0, function(){
            ShopifyAPI.addItem(id, qty, props, itemAddedCallback);
          });
        }
        else{
          ShopifyAPI.addItem(id, qty, props, itemAddedCallback);
        }
      }
      else {
        
        var line = $(this).attr('data-line'),
            qty = 0;

        ShopifyAPI.changeItem(line, qty, cartUpdateCallback);
      }
      return false;
    });
  }

  createProductRemoves = function() {
    var updateWarrantyItem = function(idx, variantId){
        ShopifyAPI.changeItem(idx, 0, function(){
          ShopifyAPI.addItem(variantId, 1, {}, function(){
            ShopifyAPI.getCart(function(cartData){
              cartUpdateCallback(cartData);
            });
          });
        });
      };
      var removeTheItem = function(line){
        ShopifyAPI.changeItem(line, 0, function(cart){
          var warrantyInfo = getWarrantyItems(cart);
          if(warrantyInfo.warrantyCartItemIndex > 0 && warrantyInfo.warrantyVariant.id !== warrantyInfo.warrantyCartItem.id){
            updateWarrantyItem(warrantyInfo.warrantyCartItemIndex, warrantyInfo.warrantyVariant.id)
          }else{
            cartUpdateCallback(cart);
          }
        });
      };
    $cartPageContainer.find('.cart__remove').on('click', function(e){
      $body.addClass('page--is-loading');
      e.preventDefault();
      var line = parseInt($(this).attr('data-line'), 10),
          qty = 0,
          gift = $(this).data('is-gift');
      if(gift){
        jQuery.post('/cart/update.js', "attributes[removed_gift_" + discountedGiftVariantId + "]=true").always(function(){
          justRemovedDiscountedGift = true;
          ShopifyAPI.changeItem(line, qty, cartUpdateCallback);
        });
      } else {
        ShopifyAPI.changeItem(line, qty, cartUpdateCallback);
      }
    });
  }

  productRemovesLoop = function(items) {
    
    var item = items.shift();
    
    var line = item.line,
        qty = 0;
    

    ShopifyAPI.changeItem(line, qty, cartUpdateCallback);
  }

  productChangeLoop = function(items) {
    var item = items.shift();
    var line = item.line,
        qty = item.qty;

    if(items.length > 0){
      ShopifyAPI.changeItem(line, qty, function(cart){productChangeLoop(items)});
    }
    else {
      ShopifyAPI.changeItem(line, qty, cartUpdateCallback);
    }
  }

  createCartAttributes = function() {
   // Save note anytime it's changed
    $body.on('change', 'select[name="attributes[Sales Associate]"]', function() {
      var associate = $(this).val();
      var attributes = {
        'Sales Associate': associate
      };

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartAttributes(attributes);
    });

    $body.on('change', 'textarea[name="attributes[Gift Message]"]', function() {
      var newMessage = $(this).val();
      var attributes = {
        'Gift Message': newMessage
      };

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartAttributes(attributes);
    });

    $body.on('change', 'input[name="attributes[gift]"]', function(e){
      $body.addClass('page--is-loading');

      if(e.target.checked){
        var value = $(e.target).val();
      }
      else{
        var value = '';
      }

      var attributes = {
        'gift': value
      };

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartAttributes(attributes, cartUpdateCallback);
    });
  }

  cartCallback = function(cart) {
    
    $body.removeClass('drawer--is-loading');
    $body.removeClass('page--is-loading');
    checkForDiscountedGift(cart, true);
    //freeWarrantyCheck(cart);

    
    var warrantyInfo = getWarrantyItems(cart);
    if(warrantyInfo.warrantyCartItemIndex > 0 && warrantyInfo.warrantyVariant.id !== warrantyInfo.warrantyCartItem.id){
      ShopifyAPI.changeItem(warrantyInfo.warrantyCartItemIndex, 0, function(cart1){
        ShopifyAPI.addItem(warrantyInfo.warrantyVariant.id, 1, {}, function(cart2){
          isUpdating = false;
          ShopifyAPI.getCart(function(cart3){
            buildCart(cart3);
          });
        });
      });
    }

    $body.trigger('afterCartLoad.ajaxCart', cart);

    if (window.Shopify && Shopify.StorefrontExpressButtons) {
      Shopify.StorefrontExpressButtons.initialize();
    }
  };

  cartPageCallback = function(cart) {
    $body.removeClass('page--is-loading');
    $body.trigger('afterCartPageLoad.ajaxCart', cart);
  };

  adjustCart = function () {
    // Delegate all events because elements reload with the cart

    // Add or remove from the quantity
    $body.on('click', '.ajaxcart__qty-adjust', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          $qtySelector = $el.siblings('.ajaxcart__qty-num'),
          qty = parseInt($qtySelector.val().replace(/\D/g, ''));

      var qty = validateQty(qty,false);

      // Add or subtract from the current quantity
      if ($el.hasClass('ajaxcart__qty--plus')) {
        qty += 1;
      } else {
        qty -= 1;
        if (qty <= 0) qty = 0;
      }

      // If it has a data-line, update the cart.
      // Otherwise, just update the input's number
      if (line) {
        $body.addClass('page--is-loading');
        updateQuantity(line, qty);
      } else {
        $qtySelector.val(qty);
      }
    });

    // Set Blur and Focus Values
    $body.on('focus', '.ajaxcart__qty-num', function() {
      $(this).attr('data-old-val', $(this).val());
      $(this).val('');
    });

    $body.on('blur', '.ajaxcart__qty-num', function() {
      if($(this).val() == ''){
        $(this).val($(this).attr('data-old-val'));
        $(this).attr('data-old-val', '');
      }
    });

    // Update quantity based on input on change
    $body.on('change', '.ajaxcart__qty-num', function() {
      if (isUpdating) {
        return;
      }

      var $el = $(this),
          line = $el.data('line'),
          qty = parseInt($el.val().replace(/\D/g, ''));

      var qty = validateQty(qty,false);

      // If it has a data-line, update the cart
      if (line) {
        $body.addClass('page--is-loading');
        updateQuantity(line, qty);
      }
    });

    // Prevent cart from being submitted while quantities are changing
    $body.on('submit', 'form.ajaxcart', function(evt) {
      if (isUpdating) {
        evt.preventDefault();
      }
    });

    // Highlight the text when focused
    $body.on('focus', '.ajaxcart__qty-adjust', function() {
      var $el = $(this);
      setTimeout(function() {
        $el.select();
      }, 50);
    });

    function updateQuantity(line, qty) {
      
      isUpdating = true;

      // Add activity classes when changing cart quantities
      var $row = $('.ajaxcart__row[data-line="' + line + '"]').addClass('is-loading');

      if (qty === 0) {
        $row.parent().addClass('is-removed');
      }

      // Slight delay to make sure removed animation is done
      setTimeout(function() {
        ShopifyAPI.changeItem(line, qty, adjustCartCallback);
      }, 250);
    }

    // Save note anytime it's changed
    $body.on('change', 'textarea[name="note"]', function() {
      var newNote = $(this).val();

      // Update the cart note in case they don't click update/checkout
      ShopifyAPI.updateCartNote(newNote);
    });
  };

  getWarrantyItems = function(cart){
    var warrantyInfo = {
      "warrantyCartItem": {},
      "warrantyCartItemIndex": -1,
      "warrantyVariant": {}
    };
    var warrantyTotal = 0;
    var items = cart.items;
    var warrantyVariantsLength = settings.warrantyProduct.variants.length;
    var warrantyVariant = settings.warrantyProduct.variants[0];
    for(var i=0; i < items.length; i++){
      if(items[i].properties != null && items[i].properties['_can_warranty']) {
        warrantyTotal += items[i].price * items[i].quantity;
      }
      if(items[i].product_id === settings.warrantyProduct.id){
        warrantyInfo.warrantyCartItem = items[i];
        warrantyInfo.warrantyCartItemIndex = i + 1;
      }
    }
    if(warrantyVariantsLength > 0){
      for(var i = 0; i < warrantyVariantsLength; i++){
        var breaks = settings.warrantyProduct.variants[i].title.split("-");
        if(parseFloat(breaks[0]) * 100 < warrantyTotal && warrantyTotal < parseFloat(breaks[1]) * 100 + 99){
          warrantyInfo.warrantyVariant = settings.warrantyProduct.variants[i];
          break;
        }
      }
    }
    return warrantyInfo;
  }

  adjustCartCallback = function (cart) {
    // Update quantity and price
    updateCountPrice(cart);

    
    var warrantyInfo = getWarrantyItems(cart);
    if(warrantyInfo.warrantyCartItemIndex > 0 && warrantyInfo.warrantyVariant.id !== warrantyInfo.warrantyCartItem.id){
      ShopifyAPI.changeItem(warrantyInfo.warrantyCartItemIndex, 0, function(cart1){
        ShopifyAPI.addItem(warrantyInfo.warrantyVariant.id, 1, {}, function(cart2){
          isUpdating = false;
          ShopifyAPI.getCart(function(cart3){
            buildCart(cart3);
          });
        });
      });
    }else{
      // Reprint cart on short timeout so you don't see the content being removed
      setTimeout(function() {
        isUpdating = false;
        ShopifyAPI.getCart(function(cart){
          buildCart(cart);
        });
      }, 150)
    }
  };

  createQtySelectors = function() {
    // If there is a normal quantity number field in the ajax cart, replace it with our version
    if ($('input[type="number"]', $cartPageContainer).length) {
      $('input[type="number"]', $cartPageContainer).each(function() {
        var $el = $(this),
            currentQty = $el.val();
        if(parseInt($el.data('id'), 10) === settings.discountedGiftVariantId){
          $el.remove();
        } else {
          var itemAdd = currentQty + 1,
              itemMinus = currentQty - 1,
              itemQty = currentQty;

          var source   = $("#AjaxQty").html(),
              template = Handlebars.compile(source),
              data = {
                key: $el.data('id'),
                itemQty: itemQty,
                itemAdd: itemAdd,
                itemMinus: itemMinus
              };

          if($el.data('line')){
            data.line = $el.data('line');
          }

          if($el.attr('readonly')){
            data.readonly = 'readonly';
          }

          // Append new quantity selector then remove original
          $el.after(template(data)).remove();
        }
      });
    }
  };

  qtySelectors = function(isModal, isExtras) {
    // Change number inputs to JS ones, similar to ajax cart but without API integration.
    // Make sure to add the existing name and id to the new input element
    var numInputs = $('input[type="number"]');

    if (numInputs.length) {
      numInputs.each(function() {
        var $el = $(this),
            currentQty = $el.val(),
            inputName = $el.attr('name'),
            inputId = $el.attr('id');

        var itemAdd = currentQty + 1,
            itemMinus = currentQty - 1,
            itemQty = currentQty;

        var source   = $("#JsQty").html(),
            template = Handlebars.compile(source),
            data = {
              key: $el.data('id'),
              itemQty: itemQty,
              itemAdd: itemAdd,
              itemMinus: itemMinus,
              inputName: inputName,
              inputId: inputId
            };

        // Append new quantity selector then remove original
        $el.after(template(data)).remove();
      });

      // Setup listeners to add/subtract from the input
      var qty_is = isModal ? $('.modal .product-selector__adjust') : $('.product-selector__adjust');

      if(isExtras){
        qty_is.off('click');
        $('.product-selector__num').off('focus');
        $('.product-selector__num').off('blur');
      }

      $('.product-selector__num').on('focus', function(){
        var $el = $(this);
        $el.attr('data-old-val', $el.val());
        $el.val('');
      });

      $('.product-selector__num').on('blur', function(){
        var $el = $(this);
        if($el.val() == ''){
          $el.val($el.attr('data-old-val'));
          $el.attr('data-old-val', '');
        }
      })

      qty_is.on('click', function() {
        var $el = $(this),
            id = $el.data('id'),
            $qtySelector = $el.siblings('.product-selector__num'),
            qty = parseInt($qtySelector.val().replace(/\D/g, ''));

        var validateToZero = ($el.closest('.extras').length > 0) ? true : false;
        var qty = validateQty(qty, validateToZero);

        // Add or subtract from the current quantity
        if ($el.hasClass('product-selector__adjust--plus')) {
          qty += 1;
        } else {
          qty -= 1;
          if($el.closest('.extras').length > 0){
            if (qty <= 0) qty = 0;
          }
          else{
            if (qty <= 1) qty = 1;
          }
        }

        // Update the input's number
        $qtySelector.val(qty).trigger('change');
      });
    }
  };

  validateQty = function (qty, validateToZero) {
    if((parseFloat(qty) == parseInt(qty)) && !isNaN(qty)) {
      // We have a valid number!
    } else {
      // Not a number. Default to 0 or 1
      if(validateToZero){
        qty = 0;
      }
      else{
        qty = 1;
      }
    }
    return qty;
  };

  updateQtySelectors = function(){
    qtySelectors(false, true);
  }

  module = {
    init: init,
    load: loadCart,
    page: loadCartPage,
    qty: updateQtySelectors
  };

  return module;

}(ajaxCart || {}, jQuery));
